import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetSnippetsParams, SnippetsResponse } from '../../../../shared/snippets';

//  Actual function to fetch snippets
function getSnippets(locator: string, params?: GetSnippetsParams) {
  return get<SnippetsResponse>(`/api/revisions/${nuc(locator)}/snippets`, false, params);
}

export const getSnippetsQueryKey = (locator: string, params?: GetSnippetsParams): QueryKey => {
  return ['revisions', locator, 'snippets', params];
};

/**
 * useSnippets is a hook that fetches and returns the snippets for the given locator.
 */
export default function useSnippets(locator: string, params?: GetSnippetsParams) {
  return useQuery<SnippetsResponse>({
    queryKey: getSnippetsQueryKey(locator, params),
    queryFn: () => getSnippets(locator, params),
  });
}
